import type { QueryClient } from "@tanstack/react-query";
import { episodeKeys } from "../modules/episodes/queries";

export function invalidateEpisodeContextQueries(
  queryClient: QueryClient,
  episodeId: string | undefined,
  currentEntityId: string | undefined,
): void {
  if (!episodeId) return;
  // @tested-by: tst_fe_ctxinvalidate_001
  // @invariant: tool results may add episode-linked entities; context panel detail must refetch immediately.
  void queryClient.invalidateQueries({ queryKey: episodeKeys.detail(episodeId) });
  if (currentEntityId) {
    void queryClient.invalidateQueries({
      queryKey: ["episodes", "list_for_entity", currentEntityId],
    });
  }
}
